import React from "react"

export default ({price, style}) => (
  <div style={{
    color: "var(--text-color)",
    fontWeight: "bold",
    textAlign: "right",
    ...style
  }}>&yen;{parseInt(price).toLocaleString()}（税込）</div>
)